import { useEffect, useState } from "react";
import { VerificationDataPageSubmissionService } from "../../../Component/Api/VerificationAgency/VerificationDataPageSubmission/VerificationDataPageSubmissionService";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Box, Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { MDBox } from "../../../Component/Common/Components/MDBox";
import { SmallLoading } from "../../../Component/Common/Components/Loading/IntermediateLoading";
import { LoadingButton } from "@mui/lab";
import { CustomDialogTitle } from "../../Common/Custom/CustomDialogTitle";
import { ApplicableDataPageAccessRequestActionsList, ApplicableDataPageSubmissionActionsList } from "../../../Component/Common/Constants/Lists/DropdownListOptions";
import AppSelectList from "../../../Component/Common/Components/FormValidationInputs/AppSelectList";
import { yupResolver } from "@hookform/resolvers/yup";
import { ActionTypes, ScorecardElements, DataPageSubmissionStatus, VaSubmissionTypes } from "../../../Component/Model/Enum/BEE123Enums";
import { VerificationDataPageSubmission } from "../../../Component/Model/Dto/VerificationAgency/VerificationDataPageSubmission";
import AppMultiSelect from "../../../Component/Common/Components/FormValidationInputs/AppMultiSelect";
import { IncomingDataPageModalSchema } from "./IncomingDataPageValidationSchema";

interface IProps {
    id: number;
    showModal: boolean;
    submissionType: VaSubmissionTypes;
    status: DataPageSubmissionStatus;
    handleCancel: () => void;
}

export const IncomingDataPageModal = (props: IProps) => {

    const [submissionId] = useState<number>(props.id);
    const [loading, setLoading] = useState<boolean>(false);
    const [elementDataPages, setElementDataPages] = useState<VerificationDataPageSubmission.DataPagesElementMap[]>([]);
    const [disabled] = useState<boolean>(props.status !== DataPageSubmissionStatus.Pending);
    const applicableActionsList = props.submissionType === VaSubmissionTypes.Request_Access ? ApplicableDataPageAccessRequestActionsList : ApplicableDataPageSubmissionActionsList;

    const { control, handleSubmit, formState: { isSubmitting }, setValue } = useForm({
        mode: "all",
        resolver: yupResolver(IncomingDataPageModalSchema)
    });

    const getDataPageSubmission = async (id: number) => {
        try {
            const result = await VerificationDataPageSubmissionService.GetSubmissionById(id);
            setElementDataPages(result.data.dataPagesElementMaps);
            if(disabled)
            {
                if(props.status === DataPageSubmissionStatus.Accepted){
                    setValue('Action', result.data.actionTypeId);
                }
                else{
                    setValue('Action',  ActionTypes.Reject);
                }
            }

        } catch (error) {
            console.log(error)
        }
        finally{
            setLoading(false);
        }
    }

    const handleDataSubmit: SubmitHandler<FieldValues> = async (submission: FieldValues) => {
        try {
            const action = submission.Action;
            const updateRequest: VerificationDataPageSubmission.UpdateDto = {
                id: submissionId,
                statusId: DataPageSubmissionStatus.Rejected,
                actionTypeId: null
            }

            if(action !== ActionTypes.Reject){

                updateRequest.statusId = DataPageSubmissionStatus.Accepted;
                updateRequest.actionTypeId = action;
            }

            const result = await VerificationDataPageSubmissionService.UpdateSubmissionStatus(updateRequest);
            handleCancel();
            toast.success("Action applied succesfully");
        } catch (error:any) {
            if(error.response){
                toast.error(error.response.data);
            }
        }
    }

    const handleCancel = () => {
        props.handleCancel();
    }

    const createElementSelectList = (elementDataPages: VerificationDataPageSubmission.DataPagesElementMap[]) => {
        return elementDataPages.map((elementDataPage) => {
            const elementId: number = elementDataPage.element.id as number;
            const dataPagesIds = elementDataPage.dataPages.map(x => x.id);
            setValue(ScorecardElements[elementId], dataPagesIds);
            return (
                <Grid item xs={6}>
                    <AppMultiSelect 
                        readOnly
                        freeSolo
                        key={ScorecardElements[elementId]}
                        control={control} 
                        options={elementDataPage.dataPages}
                        name={ScorecardElements[elementId]}
                        label={ScorecardElements[elementId]}
                    />                            
                </Grid>
            );
        })
    }

    useEffect(() => {
        setLoading(true);
        getDataPageSubmission(submissionId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.id]);

    return (
        <>
            <Box>
                <Dialog open={props.showModal} onClose={handleCancel} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth>
                    <CustomDialogTitle id="customized-dialog-title" onClose={handleCancel}>
                        {props.submissionType === VaSubmissionTypes.Request_Access ? "Incoming Requests to Edit Data Pages" : "Incoming Data Page Submissions"}
                    </CustomDialogTitle>
                    <DialogContent>
                        { !loading ? <Grid container sx={{ my: 2 }}>
                            <Grid item xs={12} lg={12} xl={12}>
                                <Box component="form" id="IncomingDataPageSubmissionForm"onSubmit={handleSubmit(handleDataSubmit)}>
                                    <MDBox>
                                        <Grid container spacing={2}>
                                            {createElementSelectList(elementDataPages)}
                                            <Grid item xs={12}>
                                                <AppSelectList
                                                    defaultValue={''}
                                                    key="ApplicableAction"
                                                    control={control}
                                                    name="Action"
                                                    label="Applicable Action"
                                                    items={applicableActionsList}
                                                    disabled={disabled}
                                                />
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                </Box>
                            </Grid>
                        </Grid> 
                    : <SmallLoading/>}
                    </DialogContent> 
                    <DialogActions>
                        <MDBox>
                            <LoadingButton variant="contained" color="primary" type="submit" form="IncomingDataPageSubmissionForm" loading={isSubmitting} disabled={disabled}>
                                Apply Action
                            </LoadingButton>
                        </MDBox>
                    </DialogActions>
                </Dialog>
            </Box>
        </>
    );
}
